import { Controller } from "@hotwired/stimulus";
import "react_ujs";

export default class extends Controller {
  static targets = ["productSelect"];
  static values = {
    productType: String,
    itemId: String,
    estimateId: String,
    duplicate: Boolean,
  };

  initialize() {
    const targets = this.productSelectTargets;
    const checkedRadio = targets.find((el) => el.checked);

    if (checkedRadio) {
      this.loadOptionsWithValue(checkedRadio.value);
    } else if (targets.length === 1 && targets[0].value) {
      this.loadOptionsWithValue(targets[0].value);
    }
  }

  loadOptions(event) {
    this.loadOptionsWithValue(event.target.value);
  }

  loadOptionsWithValue(productId) {
    if (!productId) return;

    const optionsFrame = document.getElementById(
      `${this.productTypeValue}_options`
    );
    const params = new URLSearchParams();

    if (this.itemIdValue) {
      params.append(`${this.productTypeValue}_item_id`, this.itemIdValue);
    }

    if (this.estimateIdValue) {
      params.append("estimate_id", this.estimateIdValue);
    }

    if (this.duplicateValue) {
      params.append("duplicate", "true");
    }

    optionsFrame.src = `/qc_sales/${
      this.productTypeValue
    }_products/${productId}/options?${params.toString()}`;

    optionsFrame.addEventListener(
      "turbo:frame-load",
      this.initializeReactComponents,
      { once: true }
    );
  }

  initializeReactComponents() {
    ReactRailsUJS.handleMount();
  }
}
